import React, { useContext } from 'react';
import FiltroStatusPedido from 'components/util/filtroStatusPedido/.mixins';
import { FiltersContext } from 'pages/orderHistory/hooks/FiltersContext';

export const OrderStatus = () => {
  const { filters, setFilters, clearPagination } = useContext(FiltersContext);

  const handleChangeOrderStatus = (status: string) => {
    clearPagination();
    setFilters((prev) => ({ ...prev, statusSciaIs: status }));
  };

  const orderStatusOptions = [
    { id: 'T', description: 'Todos' },
    { id: 'P', description: 'Confirmação Pendente' },
    { id: 'C', description: 'Agendamento Confirmado' },
    { id: 'R', description: 'Agendamento Recusado' },
    { id: 'E', description: 'Entrega Concluída' }
  ];

  return (
    <FiltroStatusPedido
      opcoesFiltroPedidos={orderStatusOptions}
      label="Filtro de pedidos"
      btlabel="CONFIRMAR"
      handlerFiltroPedidos={handleChangeOrderStatus}
      opcoesFiltroPedidosValue={filters.statusSciaIs}
    />
  );
};
